import api from "../../api";
import eventBus from '@/utils/eventBus';

export const serviceConfigIndex = {
  props:{
    product: {
      type: Object,
      default: {}
    }
  },
  model: {
    prop: 'productServicePrices',
    event: 'serviceConfigVal'
  },
  data() {
    return { 
      modalVisible: false,
      modalLoading: false,
      classIndex: null,
      productIndex: null,
      selectProductService: '',
      // 一级选中的服务
      mainSelectProductService: {
        productCode: undefined,
        productName: undefined,
        productDetail: undefined,
        productClassId: undefined,
        productClassCode: undefined,
        productClassName: undefined,
        productSeriesId: undefined,
        productSeriesName: undefined,
        costPrice: undefined,
        listPrice: undefined,
        selectedYear: undefined,
        productUnit:undefined,
        isStandardPrice:undefined
        
      },
      // 一级服务列表 mainServiceList
      mainServiceList: [],
      // 一级服务的年份
      mainServiceYearList: [],
      // 二级服务配置选项列表 
      secondaryServiceList: [],
      // 二级已选中的服务列表
      secondarySelectServiceList: [],
      formData: {},
      form: {
        firstLevelService: {
          productCode: '',
          selectedYear: 0,
        },
        firstLevelServiceSelectedYear: 0,
      },
      // 选中的服务列表
      productServicePrices: []
    };
  },
  methods: {
    //  进行初始化  取参
    initData() { 
      this.formData.productCode = this.product.productCode;
      this.formData.price = this.product.productPrice;
      let tcount = this.product.tCount;
      if (!tcount) {
        tcount = 1;
      }
      this.formData.quantity = this.product.purchaseQuantity * tcount;
      this.formData.productNum = this.product.purchaseQuantity * tcount;
      this.formData.packageId = this.product.servicePackageId; 
      this.formData.serviceSelectedList = this.product.serviceSelectedList;
      this.getProductServiceList();  // 调用 配置服务 接口
    },
    // 保存  事件总线 回调父组件函数
    onSubmit() {
      this.productServicePrices = [];
      let main = {
        productCode: this.mainSelectProductService.productCode,
        productName: this.mainSelectProductService.productName,
        productDetail: this.mainSelectProductService.productDetail,
        productClassId: this.mainSelectProductService.productClassId,
        productClassCode: this.mainSelectProductService.productClassCode,
        productClassName: this.mainSelectProductService.productClassName,
        productSeriesId: this.mainSelectProductService.productSeriesId,
        productSeriesName: this.mainSelectProductService.productSeriesName,
        costPrice: this.mainSelectProductService.costPrice,
        listPrice: this.mainSelectProductService.listPrice,
        selectedYear: this.mainSelectProductService.selectedYear,
        firstRetailPriceType: this.mainSelectProductService.firstRetailPriceType,
        firstRetailPriceCoefficient: this.mainSelectProductService.firstRetailPriceCoefficient,
        firstCostType: this.mainSelectProductService.firstCostType,
        firstCostCoefficient: this.mainSelectProductService.firstCostCoefficient,
        serviceLadderStandard: this.mainSelectProductService.serviceLadderStandard,
        secondRetailPriceType: this.mainSelectProductService.secondRetailPriceType,
        secondRetailPriceCoefficient: this.mainSelectProductService.secondRetailPriceCoefficient,
        secondCostType: this.mainSelectProductService.secondCostType,
        secondCostCoefficient: this.mainSelectProductService.secondCostCoefficient,
        productUnit:this.mainSelectProductService.productUnit,
        isStandardPrice: this.mainSelectProductService.isStandardPrice
      };
      this.productServicePrices.push(main);
      for (let secondaryServiceElement of this.secondarySelectServiceList) {
        let second = {
          productCode: secondaryServiceElement.productCode,
          productName: secondaryServiceElement.productName,
          productDetail: secondaryServiceElement.productDetail,
          productClassId: secondaryServiceElement.productClassId,
          productClassCode: secondaryServiceElement.productClassCode,
          productClassName: secondaryServiceElement.productClassName,
          productSeriesId: secondaryServiceElement.productSeriesId,
          productSeriesName: secondaryServiceElement.productSeriesName,
          costPrice: secondaryServiceElement.costPrice,
          listPrice: secondaryServiceElement.listPrice,
          selectedYear: secondaryServiceElement.selectedYear,
          firstRetailPriceType: secondaryServiceElement.firstRetailPriceType,
          firstRetailPriceCoefficient: secondaryServiceElement.firstRetailPriceCoefficient,
          firstCostType: secondaryServiceElement.firstCostType,
          firstCostCoefficient: secondaryServiceElement.firstCostCoefficient,
          serviceLadderStandard: secondaryServiceElement.serviceLadderStandard,
          secondRetailPriceType: secondaryServiceElement.secondRetailPriceType,
          secondRetailPriceCoefficient: secondaryServiceElement.secondRetailPriceCoefficient,
          secondCostType: secondaryServiceElement.secondCostType,
          secondCostCoefficient: secondaryServiceElement.secondCostCoefficient,
          isStandardPrice: secondaryServiceElement.isStandardPrice
        };
        if (second.productCode) {
          this.productServicePrices.push(second);
        }
      }
      // 事件总线 传值到 父组件  单个修改配置服务  将已选的配置服务传给 父组件
      eventBus.$emit('saveServiceConfig', this.productServicePrices);
    },     
    // 关闭 选择配置服务  事件总线 传递父组件 
    cancel() {
      eventBus.$emit('serviceConfigShow', false);
    },
    //  选择服务 配置 一组的 服务类型 111
    selectServiceClick(val) { 
      let row = {};
      for (const mainService of this.mainServiceList) {
        if (val === mainService.productCode) {
          row = mainService;
        }
      }
      Object.assign(this.mainSelectProductService, row);
      this.mainServiceYearList = row.yearList;
 
      for (let subIndex = 0; subIndex < row.secondaryServiceList.length; subIndex++) {
        this.secondarySelectServiceList.push({
          productCode: undefined,
          productName: undefined,
          productDetail: undefined,
          productClassId: undefined,
          productClassCode: undefined,
          productClassName: undefined,
          productSeriesId: undefined,
          productSeriesName: undefined,
          costPrice: undefined,
          listPrice: undefined,
          selectedYear: undefined,
          firstRetailPriceType: undefined,
          firstRetailPriceCoefficient: undefined,
          firstCostType: undefined,
          firstCostCoefficient: undefined,
          serviceLadderStandard: undefined,
          secondRetailPriceType: undefined,
          secondRetailPriceCoefficient: undefined,
          secondCostType: undefined,
          secondCostCoefficient: undefined,
          isStandardPrice: undefined
        });
      }
      for (let subIndex = 0; subIndex < row.secondaryServiceList.length; subIndex++) {
        for (const secondaryService of row.secondaryServiceList[subIndex].serviceProductList) {
          if (secondaryService.checked) {
            Object.assign(this.secondarySelectServiceList[subIndex], secondaryService);
          }
        } 
      }
      this.secondaryServiceList = row.secondaryServiceList;
    },
    // 选择 配置服一组的 服务时长 2222  
    serviceNumChange(value) { 
      this.mainSelectProductService.selectedYear = value;
      this.formData.serviceSelectedList = [{
        productCode: this.mainSelectProductService.productCode,
        selectedYear: this.mainSelectProductService.selectedYear
      }];
      // this.getServiceFee(this.formData, 1, null);
    },
   
    selectServiceChange(value) { 
      this.mainSelectProductService.productCode = value;
    },
    // 点击配置服务  获取产品服务列表
    getProductServiceList() { 
      let body = {
        projectId:this.product.projectId,
        packageId: this.product.servicePackageId,
        productCode: this.product.productCode,
        productNum: this.formData.productNum,
        price: this.product.productPrice,
        serviceSelectedList: this.product.serviceSelectedList
      };
      api.productServiceEcho(body).then(res => { 
        let json = res.data;
        if (json.status === '200') {
          this.mainServiceList = json.data;
          for (let mainService of this.mainServiceList) {
            if (mainService.checked) {
              Object.assign(this.mainSelectProductService, mainService);
              this.mainServiceYearList = mainService.yearList;
              this.secondarySelectServiceList = [];
              for (let subIndex = 0; subIndex < mainService.secondaryServiceList.length; subIndex++) {
                this.secondarySelectServiceList.push({
                  productCode: undefined,
                  productName: undefined,
                  yearList: undefined,
                  listPrice: undefined,
                  selectedYear: undefined,
                  productDetail: undefined,
                  productUnit:undefined,
                });
              }
              /**
               * 循环  mainService.secondaryServiceList
               * 找到 secondaryService 中 checked 为true的 对象 
               * 进行合并 到 secondarySelectServiceList[subIndex]
               *  合并到二级已选中的服务列表
              */
              for (let subIndex = 0; subIndex < mainService.secondaryServiceList.length; subIndex++) {
                for (const secondaryService of mainService.secondaryServiceList[subIndex].serviceProductList) {
                  if (secondaryService.checked) {
                    Object.assign(this.secondarySelectServiceList[subIndex], secondaryService);
                  }
                }
              }
              //  赋值个给 secondaryServiceList 二级服务列表
              this.secondaryServiceList = mainService.secondaryServiceList;
            }
          }
        }
        this.modalLoading = false;
      }).catch(e => {
        this.modalLoading = false;
      });
    }, 
    // 将选中的服务可选年份动态加载出来  服务类型  第二组 服务类型 3333 
    secondarySelectServiceClick (row, index, val) {
      for (const serviceProduct of row.serviceProductList) {
        if (serviceProduct.productCode === val.productCode) {
          Object.assign(this.secondarySelectServiceList[index], serviceProduct);
          console.log('secondarySelectServiceList[index]',this.secondarySelectServiceList[index]);
        }
      }
    },


    // 查询选择服务的费用 
    // getServiceFee(params, level, index) {
    //   api.calcServiceFee(params).then(res => {
    //     let json = res.data;
    //     if (json.status === '200') {
    //       this.serviceDataReturn(json.data, level, index);
    //     }
    //   }).catch(e => {
    //     console.error(e);
    //   });
    // },
    // serviceDataReturn(data, level, index) {
    //   console.log('serviceDataReturn', data);
    //   if (level === 1) {
    //     this.mainSelectProductService.productCode = data.serviceList[0].productCode;
    //     this.mainSelectProductService.productName = data.serviceList[0].productName;
    //     this.mainSelectProductService.productDetail = data.serviceList[0].productDetail;
    //     this.mainSelectProductService.productClassId = data.serviceList[0].productClassId;
    //     this.mainSelectProductService.productClassCode = data.serviceList[0].productClassCode;
    //     this.mainSelectProductService.productClassName = data.serviceList[0].productClassName;
    //     this.mainSelectProductService.productSeriesId = data.serviceList[0].productSeriesId;
    //     this.mainSelectProductService.productSeriesName = data.serviceList[0].productSeriesName;
    //     this.mainSelectProductService.listPrice = data.serviceList[0].listPrice;
    //     this.mainSelectProductService.costPrice = data.serviceList[0].costPrice;
    //     this.mainSelectProductService.selectedYear = data.serviceList[0].selectedYear;
    //     this.mainSelectProductService.firstRetailPriceType = data.serviceList[0].firstRetailPriceType;
    //     this.mainSelectProductService.firstRetailPriceCoefficient = data.serviceList[0].firstRetailPriceCoefficient;
    //     this.mainSelectProductService.firstCostType = data.serviceList[0].firstCostType;
    //     this.mainSelectProductService.firstCostCoefficient = data.serviceList[0].firstCostCoefficient;
    //     this.mainSelectProductService.serviceLadderStandard = data.serviceList[0].serviceLadderStandard;
    //     this.mainSelectProductService.secondRetailPriceType = data.serviceList[0].secondRetailPriceType;
    //     this.mainSelectProductService.secondRetailPriceCoefficient = data.serviceList[0].secondRetailPriceCoefficient;
    //     this.mainSelectProductService.secondCostType = data.serviceList[0].secondCostType;
    //     this.mainSelectProductService.secondCostCoefficient = data.serviceList[0].secondCostCoefficient;
    //     this.mainSelectProductService.productUnit = data.serviceList[0].productUnit;

    //   } else if (level === 2) {
    //     console.log(this.secondarySelectServiceList[index]);
    //     if (data && data.serviceList[0] && this.secondarySelectServiceList[index]) {
    //       this.secondarySelectServiceList[index].productCode = data.serviceList[0].productCode;
    //       this.secondarySelectServiceList[index].productName = data.serviceList[0].productName;
    //       this.secondarySelectServiceList[index].productDetail = data.serviceList[0].productDetail;
    //       this.secondarySelectServiceList[index].productClassId = data.serviceList[0].productClassId;
    //       this.secondarySelectServiceList[index].productClassCode = data.serviceList[0].productClassCode;
    //       this.secondarySelectServiceList[index].productClassName = data.serviceList[0].productClassName;
    //       this.secondarySelectServiceList[index].productSeriesId = data.serviceList[0].productSeriesId;
    //       this.secondarySelectServiceList[index].productSeriesName = data.serviceList[0].productSeriesName;
    //       this.secondarySelectServiceList[index].listPrice = data.serviceList[0].listPrice;
    //       this.secondarySelectServiceList[index].costPrice = data.serviceList[0].costPrice;
    //       this.secondarySelectServiceList[index].selectedYear = data.serviceList[0].selectedYear;
    //       this.secondarySelectServiceList[index].firstRetailPriceType = data.serviceList[0].firstRetailPriceType;
    //       this.secondarySelectServiceList[index].firstRetailPriceCoefficient = data.serviceList[0].firstRetailPriceCoefficient;
    //       this.secondarySelectServiceList[index].firstCostType = data.serviceList[0].firstCostType;
    //       this.secondarySelectServiceList[index].firstCostCoefficient = data.serviceList[0].firstCostCoefficient;
    //       this.secondarySelectServiceList[index].serviceLadderStandard = data.serviceList[0].serviceLadderStandard;
    //       this.secondarySelectServiceList[index].secondRetailPriceType = data.serviceList[0].secondRetailPriceType;
    //       this.secondarySelectServiceList[index].secondRetailPriceCoefficient = data.serviceList[0].secondRetailPriceCoefficient;
    //       this.secondarySelectServiceList[index].secondCostType = data.serviceList[0].secondCostType;
    //       this.secondarySelectServiceList[index].secondCostCoefficient = data.serviceList[0].secondCostCoefficient;
    //       this.secondarySelectServiceList[index].productUnit = data.serviceList[0].productUnit;
    //     }
    //   }
    // },
    


    
    // 选择 第二组服务配置 时长 444
    secondaryServiceNumChange (value, index) {
      this.formData.serviceSelectedList = [
        { 
          productCode: this.secondarySelectServiceList[index].productCode, 
          selectedYear: this.secondarySelectServiceList[index].selectedYear 
        }
      ];
      // this.getServiceFee(this.formData, 2, index);
    }
  },
  mounted() {
    // console.log('product', this.product);  // 父组件传递 子组件 ===》 传递来参数
    this.initData();  // 页面加载完毕 调用
  },
};
 

